import React from 'react';
import { Box, Button } from '@mui/material';
import BackButton from './BackButton';
import ProgressIndicator from './ProgressIndicator';

interface BreadcrumbsProps {
  currentStep: number;
  onClickBack: () => void;
  noBackButton?: boolean;
  isSkip?: boolean;
  handleSkip?: () => void;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ currentStep, onClickBack, noBackButton = false, isSkip = false, handleSkip }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        typography: 'body1',
        height: 50,
      }}
    >
      {!noBackButton && <BackButton onClick={onClickBack} />}
      <Box sx={{ flex: 1 }} />
      {isSkip && <Button onClick={handleSkip} sx={{ textTransform: 'capitalize' , color:'white'}}>Skip</Button>}
      {currentStep > 0 && <ProgressIndicator currentStep={currentStep} />}
    </Box>
  );
};

export default Breadcrumbs;
